import { render, staticRenderFns } from "./AbusePieChart.vue?vue&type=template&id=5da59c69&"
import script from "./AbusePieChart.vue?vue&type=script&lang=js&"
export * from "./AbusePieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports